import { TextAnimation } from './text-animation';

class Recherche {
  private selectedLink = null;
  private primarySelect = document.querySelector(
    'select[name="secteur-primaire"]'
  );
  private select: any = document.querySelector('select[name="secteur"]');
  private wordsList = document.querySelectorAll('.recherche__words_list');

  constructor() {
    if (this.select && this.select?.options[this.select?.selectedIndex]) {
      this.selectedLink =
        this.select?.options[this.select?.selectedIndex].value;
    }
    if (this.select) {
      this._init();
    }
    if (this.wordsList.length > 0) {
      const left = document.querySelector('.recherche__left');
      if (left) {
        const heading = left.querySelector('h1');
        const span = document.createElement('span');
        span.setAttribute('id', 'word');
        heading?.append(span);
        TextAnimation.startAnimation(
          this.wordsList,
          document.getElementById('word')
        );
      }
    }
  }

  private _init(): void {
    this.select?.addEventListener('change', (e) => {
      this.selectedLink = e?.target?.value;
    });
    this.primarySelect?.addEventListener('change', (e: any) => {
      const value = e?.target?.value;
      this.getChildren(value);
    });
    const btn = document.getElementById('gotToSector');
    btn?.addEventListener('click', () => {
      if (this.selectedLink !== null) {
        document.location = this.selectedLink;
      }
    });
  }

  private getChildren(value: string): void {
    const url = document.location.href + 'wp-json/wp/v2/recherche/' + value;
    try {
      fetch(url, {
        method: 'GET'
      })
        .then((response) => response.json())
        .then((res) => {
          this.updateSelect(res);
        });
    } catch (e) { }
  }

  private updateSelect(data: any[]): void {
    this.select.innerHTML = '';
    data.forEach((d) => {
      this.select.innerHTML += `<option value='${d.link}'>${d.name}</option>`;
    });
    this.selectedLink = this.select?.options[this.select?.selectedIndex].value;
  }
}

export const recherche = new Recherche();
